import { FunctionComponent } from 'react';

import HtmlStyledContent from 'components/layout/HtmlStyledContent';

import Title from '../Title';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobDescription: FunctionComponent<Props> = ({
    title,
    stages,
}) => {
    return (
        <StyledComponent
            className="public-page-company-site-section-company-block-stagesdescription"
        >
            <Title
                title={title}
            />
            <div className="list">
                <div className="list-element">
                    <HtmlStyledContent
                        className="element-content"
                        html={stages}
                    />
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobDescription;